import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import BlankState from '../../../../components/BlankState';
import StatusMessages2 from '../../../../components/StatusMessages2';
import Cleave from 'cleave.js/react';


import { listBranches } from '../../../../actions/branches';
import { saveCompany, updateCompany, listCovers, listCompanies } from '../../../../actions/openCovers';


class AddCompany extends Component{

    constructor(props){
        super(props);

        this.state = {
            company: {
                is_active: false,
                is_custom_rates: false,
                certificate: ''
            },
            updatedCompany: {}
        };
    }

    componentDidMount(){
        const { listBranches, listCovers } = this.props;
        const insurer = this.props.user.userInfo.insurer;

        listCompanies(insurer)
        listBranches(insurer);
        listCovers();
    }

    componentWillReceiveProps(nextProps){
        this.setState({
            company: nextProps.editCompany || {},
            updatedCompany: {
                id: nextProps.editCompany ? nextProps.editCompany.id : ''
            }
        });
    }

    onChange = (e) =>{
        e.preventDefault();
        const { name, value } = e.target;
        const { company, updatedCompany } = this.state;

        this.setState({
            company: {
                ...company,
                [name]: value
            },
            updatedCompany: {
                ...updatedCompany,
                [name]: value
            }
        });
    }

    /* Select insuranance and branch */
    onSelectBranch = (e) => {
        e.preventDefault();
        const { selectedIndex } = e.target;
        const { branches } = this.props.branches;
        const { company, updatedCompany } = this.state;

        const insurer = { insurer: branches[selectedIndex - 1].insurer };
        const { name, value } = e.target;
        
        this.setState({
            company: {
                ...company,
                ...insurer,
                [name] : value
            },
            updatedCompany: {
                ...updatedCompany,
                ...insurer
            }
        });
    }
    
    createCompany = (e) => {
        e.preventDefault();
        const { company, updatedCompany } = this.state;

        if(!company.hasOwnProperty('id')){
            this.props.saveCompany(company);          
        }
        else{
            this.props.updateCompany(updatedCompany);
        }
        
    }

    render(){
        const { company } = this.state;
        const { branches, covers } = this.props;
        
        return(
            <form   
                className="form-horizontal" 
                onSubmit={ this.createCompany }>

                <div className="col-sm-offset-4 col-sm-8">
                {
                    covers.createCompanyLoading ?

                        <BlankState 
                            data={ false }
                            customMessage="Saving details..."
                            isDataLoading={ covers.createCompanyLoading } />
                    :
                        <div>
                        {
                            covers.errorMessageCreateCompany ?
                                
                                <StatusMessages2 
                                    type="error"
                                    message={ 
                                        covers.errorMessageCreateCompany !== undefined ? 
                                            covers.errorMessageCreateCompany
                                        : '' 
                                    } />
                            : null
                        }
                        {   
                            covers.successCreateCompany ?
                                <StatusMessages2 
                                    type="success" 
                                    message="Details saved" />
                            : null
                        }
                        </div>
                }
                </div>
            
                <div className="form-group">
                    <label className="col-sm-4 control-label">Company Name:
                        <span className="text-danger">*</span>
                    </label>
                    <div className="col-sm-8">
                        <input 
                            type="text" 
                            className="form-control" 
                            name="name" 
                            onChange={ this.onChange }
                            value={ company.name || '' }
                            required />
                    </div>
                </div>
                
                <div className="form-group">
                    <label className="col-sm-4 control-label">Insurer Branch: <span className="text-danger">*</span></label>
                    <div className="col-sm-8">
                        <select 
                            className="form-control"
                            name="insurer_branch"
                            onChange={ this.onSelectBranch }
                            value={ company.insurer_branch || '' }>

                            <option value="">Select a Branch</option>
                            {
                                branches.branches.map((branch, index)=>{
                                    return(
                                        <option key={ index } value={ branch.id }>
                                            { branch.branch_name }
                                        </option>
                                    )
                                })
                            }
                        </select>
                    </div>
                </div>

                <div className="form-group">
                    <label className="col-sm-4 control-label">Email:
                        <span className="text-danger">*</span>
                    </label>
                    <div className="col-sm-8">
                        <input 
                            type="email"
                            className="form-control" 
                            name="email"
                            onChange={ this.onChange }
                            value={ company.email || "" } 
                            required="required"
                            autoFocus />
                    </div>
                </div>
                
                <div className="form-group">
                    <label className="col-sm-4 control-label">Phone Number:
                        <span className="text-danger">*</span>
                    </label>
                    <div className="col-sm-8">
                        <input 
                            type="number"
                            min="0"
                            className="form-control"
                            name="phone"
                            onChange={ this.onChange }
                            value={ company.phone || '' }
                            required />
                    </div>
                </div>

                <div className="form-group">
                    <label className="col-sm-4 control-label">Postal Address:
                        <span className="text-danger">*</span>
                    </label>
                    <div className="col-sm-8">
                        <input 
                            type="text"
                            name="postal_address"
                            className="form-control"
                            onChange={ this.onChange }
                            value={ company.postal_address || '' }
                            required />
                    </div>
                </div>

                <div className="form-group">
                    <label className="col-sm-4 control-label">Tax Identification Number:
                        <span className="text-danger">*</span>
                    </label>
                    <div className="col-sm-8">
                      

                        <Cleave options={
                            {blocks: [3,3,4],
                                delimiter: '-',
                                numericOnly: true }
                            }
                            className="form-control"
                            name="tra_pin"
                            label="Tax Payer PIN" 
                            type="text"
                            validations={ ['required'] }
                            value={ company.tra_pin }
                            onChange={this.onChange}/>
                    </div>
                </div>
                <div className="form-group">
                    <div className="col-sm-8 col-sm-offset-4">
                        {
                            company.hasOwnProperty('id') ? 
                                <button type="submit" className="btn btn-warning">
                                    <i className="icon ion-edit"></i> Edit Company
                                </button>
                            :
                                <button type="submit" className="btn btn-success">
                                    <i className="icon ion-checkmark"></i> Create Company
                                </button>
                        }
                    </div>
                </div>
            </form>
        );
    }
}
const mapStateToProps = (state, ownProps) => ({
    branches: state.branches,
    user: state.user,
    covers: state.covers
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({ saveCompany, updateCompany, listBranches, listCovers, listCompanies }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(AddCompany);



// WEBPACK FOOTER //
// ./src/pages/dashboard/policies/open-covers/AddCompany.jsx